import React from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import {getRouteRedirect} from '../../roles'

/** Redirects before rendering, so a forbidden page never mounts or issues its requests. */
export default function RouteAuthorizationGate({children}: {children: React.ReactNode}) {
  const {me} = useAuth()
  const location = useLocation()
  const redirect = me ? getRouteRedirect(me.role, location.pathname) : null
  if (redirect) return <Navigate to={redirect} replace />
  return <>{children}</>
}
